import { createMuiTheme } from "@material-ui/core/styles";
import type { AlertProps } from "@material-ui/lab/Alert/Alert";
import React from "react";
import { CheckCircleIcon } from "components/icons/CheckCircleIcon";
import { WarningIcon } from "components/icons/WarningIcon";

declare module "@material-ui/core/styles" {
  interface Theme {
    Typography: {
      fontFamily: string[];
    };
  }

  interface ThemeOptions {
    Typography?: {
      fontFamily?: string[];
    };
  }

  export interface ComponentsPropsList {
    MuiAlert: AlertProps;
  }
}

export const MUI_THEME = createMuiTheme({
  typography: {
    fontFamily: [
      "Lato",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
    MuiAlert: {
      iconMapping: { success: <CheckCircleIcon />, warning: <WarningIcon /> },
    },
  },
  palette: {
    primary: {
      main: "#4D79EA",
    },
    secondary: {
      main: "#E05843",
    },
  },
});
